export enum BookAppointmentImplementation {
  HUBSPOT = 'hubspot_calendar',
  CALENDLY = 'calendly',
  CALLBACK = 'callback_form',
  LIVE_AGENT = 'live_agent',
  CUSTOM_CALENDAR = 'custom_calendar',
}
